export default "__VITE_ASSET__CnONVCgG__"